module.exports = __webpack_public_path__ + "static/img/otp4.ce0767a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/otp4.svg
// module id = m5ip
// module chunks = 1